import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { usePreferredPMSVersion } from '~/composables/usePreferredPMSVersion'

const refreshPreferredVersion = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): void => {
  usePreferredPMSVersion().refresh()

  return next()
}

export default refreshPreferredVersion
